import BaseService from "./BaseService.js";

class QueryService extends BaseService {
  getSubject(id, sourceId = 'all') {
    return this.apiGet({
      url: `/query/${id}/${sourceId}`,
      isStore: true,
      params: { sourceId },
    });
  }

  getEntities(page, perPage) {
    return this.apiGet({
      url: `/query/entities`,
      isStore: true,
      params: { pagination: { page, perPage } },
    });
  }

  getLocaitons(page, perPage, activeFilters, signal) {
    return this.apiGet({
      signal,
      url: `/query/locations`,
      isStore: true,
      params: {
        pagination: { page, perPage },
        ...activeFilters,
      },
    });
  }

  searchLocations(search) {
    return this.apiGet({
      isStore: true,
      url: `/query/locations`,
      params: { search },
    });
  }
}

export default new QueryService();
